import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const SearchContext = createContext(null);

const PLACEHOLDERS = {
  "/app/tenants": "Search tenants by name, phone, house…",
  "/app/properties": "Search properties by name, address…",
  "/app/rent": "Search tenants by name, house…",
  "/app/calls": "Search AI calls by tenant…",
  "/app/sms": "Search SMS by tenant or message…",
  "/app/utilities": "Search tenants by name, house…",
};

export function SearchProvider({ children }) {
  const location = useLocation();
  const [query, setQuery] = useState("");

  // Clear the query whenever the route changes.
  useEffect(() => {
    setQuery("");
  }, [location.pathname]);

  const path = location.pathname.startsWith("/app/properties/")
    ? "/app/properties"
    : location.pathname;
  const placeholder = PLACEHOLDERS[path] || "Search…";
  const enabled = path in PLACEHOLDERS || path.startsWith("/app/properties/");

  return (
    <SearchContext.Provider value={{ query, setQuery, placeholder, enabled }}>
      {children}
    </SearchContext.Provider>
  );
}

export function useSearch() {
  const ctx = useContext(SearchContext);
  if (!ctx) throw new Error("useSearch must be used within SearchProvider");
  return ctx;
}

// Helper: case-insensitive substring match against multiple fields.
export function matchesQuery(query, ...fields) {
  const q = String(query || "").trim().toLowerCase();
  if (!q) return true;
  return fields.some((f) =>
    String(f || "").toLowerCase().includes(q)
  );
}
